angular.module("digitalLeasing.module").component("warrantiesManagement", {
    templateUrl: "ng/components/digitalLeasing/goodManagement/warrantiesManagement/warrantiesManagement.view.html",
    bindings: {
        model: "<", //elementToAdd
        preventivo: "=",
        customer: "=",
        warrantyIsOk: "&",
        warrantyIsNotOk: "&",
        warrantyIndex: "=",
        elementToSave: "&",
        snapshot: '<',
        portalRunned:'<',
        vendor:'<'
    },
    controllerAs: "warraManagementCtrl",
    controller: WarrManagementController
});

function WarrManagementController(
    $timeout,
    $financialApiService
) {
    var self = this;

    self.$onInit = function () {
        self.numberOfCharMax = 20;
        self.indexOfWarrantiesPFSelected = []
        self.indexOfWarrantiesAziendaSelected = []
        self.supportModel = {
            tempGaranzia: {},
            garanziaList: [],
            warrantyList: [],
            cdGarSelected: "",
            warrantyDetailsList: [],
            isPersona: false,
            subjectGarantiReturned: false,
            subjectFirmatariReturned: false,
            idCespitiList: [],
            goodLoader: false,
            warrantor: [],
            amountAvailable: 0,
            dataInizioScadenza: "",
            beneSelected: [],
            guarLoader: false
        }

        $timeout(function () {
            if (!self.model.codice && self.preventivo.garanzie.length > 0) {
                for (var i = 0; i < self.preventivo.garanzie.length; i++) {
                    if (self.warrantyIndex == null) {
                        self.supportModel.garanziaList = Object.assign({},self.model);
                    } else {
                        
                        self.preventivo.garanzie[self.warrantyIndex].listaGaranti = self.model.listaGaranti;
                        self.supportModel.garanziaList = Object.assign({},self.preventivo.garanzie[self.warrantyIndex]);
                    }
                }
            } else if (self.preventivo.garanzie == 0 || self.warrantyIndex == null) {
                self.supportModel.garanziaList = Object.assign({},self.model);
            }

            if (self.model.listaGaranti.length > self.supportModel.garanziaList.listaGaranti.length) {
                self.model.listaGaranti.forEach(function (el) {
                    var garante = self.supportModel.garanziaList.listaGaranti.some(function (element) {
                        return element.cfGarante == el.cfGarante
                    })

                    if (!garante) {
                        self.supportModel.garanziaList.listaGaranti.push(el);
                    }
                });
            }

            if (self.supportModel.garanziaList.descrizione || self.supportModel.garanziaList.codice) {
                self.supportModel.tempGaranzia = {
                    cdGar: self.supportModel.garanziaList.codice,
                    dsGar: self.supportModel.garanziaList.descrizione
                }
            }

            //recupero solo l'importoDefault
            if (self.supportModel.garanziaList.importoInizialeGaranzia > 0) {
                self.retrieveGuaranteeDetails(self.supportModel.garanziaList.codice, true);
            }

            if (typeof self.supportModel.garanziaList.id === "undefined" || self.supportModel.garanziaList.id == null) {
                if (self.preventivo.garanzie && self.preventivo.garanzie.length > 1) {
                    var lastGar = self.preventivo.garanzie.length;
                    self.supportModel.garanziaList.id = parseInt(lastGar) + 1;
                } else if (self.preventivo.garanzie && self.preventivo.garanzie.length == 1) {
                    self.supportModel.garanziaList.id = "2";
                } else {
                    self.supportModel.garanziaList.id = "1"
                }
            }

            self.preventivo.prodotto.beneContratto.forEach(function (element) {
                var fornitore ='';
                if (element.fornitore.riUserG && (element.fornitore.riUserG.cf || element.fornitore.riUserG.ragioneSociale)) {
                    fornitore = element.fornitore.riUserG.cf ? element.fornitore.riUserG.cf : element.fornitore.riUserG.ragioneSociale;
                } else if(element.fornitore && element.fornitore.riUserF && element.fornitore.riUserF.cf){
                    fornitore = element.fornitore.riUserF.cf
                }
                self.supportModel.idCespitiList.push({
                    id: element.idBene,
                    amount: element.importoCespite,
                    codice: element.codiceCDU,
                    provider: fornitore,
                    dataConsegna: element.dataDiConsegna
                });
            });

            //prevalorizzo la selezione se presente e obbligatoria
            if (self.supportModel.garanziaList.flagBeneObbligatorio) {
                self.supportModel.idCespitiList.forEach(function (el) {
                    if (self.supportModel.garanziaList.idBene === el.id) {
                        self.supportModel.beneSelected = el;
                    }
                });
            } else {
                self.supportModel.beneSelected = {};
            }
        }, 2000);

        checkAndEnableTooltip();
        retrieveGuarantee();

    };

    self.handleChange = function (property, value) {
        switch (property) {
            case "codice":
                self.supportModel.tempGaranzia = value;
                self.supportModel.garanziaList.codice = value.cdGar;
                self.supportModel.garanziaList.descrizione = value.dsGar;
                self.supportModel.beneSelected = null;
                self.retrieveGuaranteeDetails(value.cdGar);
                break;
            case "idCespite":
                self.supportModel.garanziaList.idBene = value.id;
                self.supportModel.beneSelected = value;
                break;
            case "importPerc":
                self.supportModel.garanziaList.importoInizialeGaranzia = value.currency;
                self.supportModel.garanziaList.percentualeGaranzia = value.percent;
                break;
            default:
                self.supportModel.garanziaList[property] = value;
                break;
        }
        validateWarranties();

    };

    self.retrieveGuaranteeDetails = function (codiceGar, retrieveData) {
        self.supportModel.goodLoader = true;
        if (retrieveData) {
            $financialApiService
                .getGuaranteeDetails(self.preventivo.pianoFinanziario.durataMesi, codiceGar, self.preventivo)
                .then(function (warrDetailResponse) {
                    self.supportModel.goodLoader = false;
                    $timeout(function () {
                        self.supportModel.garanziaList.importoDefault = Math.round(warrDetailResponse[0].importoDefault * 100 + getEpsilon())/100;
                        self.supportModel.cdGarSelected = true;
                    }, 2000);

                }).catch(function (error) {
                    self.supportModel.goodLoader = false;
                    console.error(error);
                });
        } else {
            $financialApiService
                .getGuaranteeDetails(self.preventivo.pianoFinanziario.durataMesi, codiceGar, self.preventivo)
                .then(function (warrDetailResponse) {
                    self.supportModel.goodLoader = false;
                    self.supportModel.garanziaList.idBene = null;
                    $timeout(function () {
                        self.supportModel.garanziaList.dataInizio = warrDetailResponse[0].dataInizio;
                        self.supportModel.garanziaList.dataScadenza = warrDetailResponse[0].dataScadenza;
                        self.supportModel.garanziaList.dataScadenzaObbligatoria = warrDetailResponse[0].dataScadenzaObbligatoria;
                        self.supportModel.garanziaList.flagBeneObbligatorio = warrDetailResponse[0].flagBeneObbligatorio;
                        self.supportModel.garanziaList.flagDataEmissioneObbligatoria = warrDetailResponse[0].flagDataEmissioneObbligatoria;
                        self.supportModel.garanziaList.flagDepositoAmministrato = warrDetailResponse[0].flagDepositoAmministrato;
                        self.supportModel.garanziaList.flagCointestazDefault = warrDetailResponse[0].flagCointestazDefault;
                        self.supportModel.garanziaList.flagFirmatarioObbligatorio = warrDetailResponse[0].flagFirmatarioObbligatorio;
                        self.supportModel.garanziaList.flagFirmatarioObbligatorioDefault = warrDetailResponse[0].flagFirmatarioObbligatorioDefault;
                        self.supportModel.garanziaList.flagPercentualeGaranzia = warrDetailResponse[0].flagPercentualeGaranzia;
                        self.supportModel.garanziaList.modCalcoloImportoGaranzia = warrDetailResponse[0].modCalcoloImportoGaranzia;
                        self.supportModel.garanziaList.note = warrDetailResponse[0].note;
                        self.supportModel.garanziaList.importoDefault = Math.round(warrDetailResponse[0].importoDefault * 100 + getEpsilon())/100;
                        self.supportModel.garanziaList.percentualeDefault = warrDetailResponse[0].percentualeDefault;
                        self.supportModel.garanziaList.importoInizialeGaranzia =
                            warrDetailResponse[0].importoInizialeGaranzia > 0 ? warrDetailResponse[0].importoInizialeGaranzia : warrDetailResponse[0].importoDefault;
                        self.supportModel.garanziaList.percentualeGaranzia =
                            warrDetailResponse[0].percentualeGaranzia > 0 ? warrDetailResponse[0].percentualeGaranzia : 100;
                        self.supportModel.garanziaList.numeroGaranzia = warrDetailResponse[0].numeroGaranzia;

                        self.supportModel.cdGarSelected = true;

                        if (!self.supportModel.garanziaList.flagBeneObbligatorio) {
                            self.model.idCespite = "";
                        } else {
                            if (self.supportModel.idCespitiList.length == 1) {
                                self.handleChange("idCespite", self.supportModel.idCespitiList[0]);
                            }
                        }

                        validateWarranties();
                    }, 1000);

                }).catch(function (error) {
                    self.supportModel.goodLoader = false;
                    console.error(error);
                });
        }
    }

    self.check = function (garante, type) {
        garante[type].selected = !garante[type].selected;
        checkGarantiPFSelecter(garante);
        garanteFirmatarioSelected(garante, type);

    }

    var validateWarranties = function () {
        var testGaranti = false;
        var testGaranzia = false;
        var testBeneInGaranzia = false;

        if (self.supportModel.garanziaList.listaGaranti) {
            testGaranti = self.supportModel.garanziaList.listaGaranti
                .some(function (element) {
                    return element.garante.selected == true;
                })

            testGaranzia = !!self.supportModel.garanziaList.codice &&
                !!self.supportModel.garanziaList.importoInizialeGaranzia &&
                !!self.supportModel.garanziaList.percentualeGaranzia

            if (self.supportModel.garanziaList.flagBeneObbligatorio) {
                testBeneInGaranzia = !!self.supportModel.garanziaList.idBene
            } else {
                testBeneInGaranzia = true;
            }

            if (testGaranti && testGaranzia && testBeneInGaranzia) {
                self.warrantyIsOk();
                self.elementToSave({
                    warranty: self.supportModel.garanziaList
                });
            } else {
                self.warrantyIsNotOk();
            }
        }
    }

    var checkAndEnableTooltip = function () {
        $timeout(function () {
            if (self.customer.metadata.riUserG.ragioneSociale && self.customer.metadata.riUserG.ragioneSociale.length > self.numberOfCharMax) {
                self.enableToltipRagSocWarr = true;
            }
        }, 400);
    }

    var retrieveGuarantee = function () {
        self.supportModel.retrieveGuarantee = true;
        $financialApiService
            .getGuarantee(self.vendor.riUserG.ndg)
            .then(function (warrantyResponse) {
                self.supportModel.warrantyList = warrantyResponse;
                self.supportModel.retrieveGuarantee = false;
            }).catch(function (error) {
                console.error(error);
                self.supportModel.retrieveGuarantee = false;
            });
    }

    var garanteFirmatarioSelected = function (garante, type) {
        var x = self.model.listaGaranti.findIndex(function (elem) {

            return elem.cfGarante == garante.cfGarante;

        })
        var numGaranti = self.model.listaGaranti && self.model.listaGaranti
            .filter(function (element) {
                return element.garante.selected == true;
            }).length;

        if (type == "firmatario" && numGaranti > 1) {

            self.model.listaGaranti[x].garante.selected = true;
            if (self.model.listaGaranti[x].firmatario.selected) {

                self.model.listaGaranti.forEach(function (element, index) {
                    if (index != x) {
                        element.firmatario.selected = false;
                    }
                })
            }

        } else {

            if (garante.azienda) {
                self.indexOfWarrantiesPFSelected = [];
                self.supportModel.garanziaList.listaGaranti
                    .forEach(function (element) {
                        if (!element.azienda) {
                            element.garante.selected = false;
                            element.firmatario.selected = false;
                        } else {
                            if (element.cfGarante == garante.cfGarante && element.garante.selected) {
                                element.firmatario.selected = true;
                            } else {
                                element.firmatario.selected = false;
                            }
                        }
                    })
            } else if (!garante.azienda) {
                self.indexOfWarrantiesAziendaSelected = [];
                self.supportModel.garanziaList.listaGaranti
                    .forEach(function (element) {
                        if (element.azienda) {
                            element.garante.selected = false;
                            element.firmatario.selected = false;
                        }
                    })

            } else {

                if (garante.azienda) {
                    self.indexOfWarrantiesPFSelected = [];
                    self.supportModel.garanziaList.listaGaranti
                        .forEach(function (element) {
                            if (!element.azienda) {
                                element.garante.selected = false;
                                element.firmatario.selected = false;
                            } else {
                                if (element.cfGarante == garante.cfGarante) {
                                    //element.firmatario.selected = true; commento per capire se quando seleziono un'azienda come garante devo spuntarla anche come firmatario 
                                    //visto che la checkbox non è più presente 
                                }
                            }
                        })
                } else if (!garante.azienda) {
                    self.indexOfWarrantiesAziendaSelected = [];
                    self.supportModel.garanziaList.listaGaranti
                        .forEach(function (element) {
                            if (element.azienda) {
                                element.garante.selected = false;
                                element.firmatario.selected = false;
                            }
                        })

                    if (numGaranti > 1 && type == "garante") {
                        self.model.listaGaranti[x].firmatario.selected = self.model.listaGaranti[x].garante.selected && true;

                        if (self.model.listaGaranti[x].firmatario.selected) {
                            self.model.listaGaranti.forEach(function (element, index) {
                                if (index != x) {
                                    element.firmatario.selected = false;
                                }
                            })
                        }
                    }
                }
            }
        }
        validateWarranties();
    }

    var checkGarantiPFSelecter = function (garante) {
        var x = self.model.listaGaranti.findIndex(function (elem) {
            return elem.cfGarante == garante.cfGarante;
        })
        if (!garante.azienda) {
            self.indexOfWarrantiesPFSelected.push(x);
        } else {
            if (garante.garante.selected) {
                self.indexOfWarrantiesAziendaSelected.push(x);
            } else {
                self.indexOfWarrantiesAziendaSelected.shift();
            }
        }


        if (self.indexOfWarrantiesAziendaSelected.length > 1) {

            var remove = self.indexOfWarrantiesAziendaSelected.shift();
            self.model.listaGaranti[remove].garante.selected = false;
            self.model.listaGaranti[remove].firmatario.selected = false;

        }
    }

    var getEpsilon= function() {
      var e = 1.0;
      while ( ( 1.0 + 0.5 * e ) !== 1.0 ){
          e *= 0.5;
      }
        
      return e;
    }
}